import type { FormInstance } from 'antd';
import type { ProdutoAdicionalBody } from '@/features/produto-adicional/types/ProdutoAdicional';
import type { ProdutoAdicionalItemBody } from '@/features/produto-adicional/types/ProdutoAdicionalItem';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { ProdutoProdutoAdicionalBody } from '@/features/produto/types/ProdutoProdutoAdicional';
import type { DialogState } from '@/std/dialog/types';
import { uuid } from '@/std/util';

export function addOrEditAdicionalItemForm(
    formProduto: FormInstance<FormProdutoValues>,
    dialogState: DialogState<ProdutoAdicionalItemBody>,
    adicional: ProdutoAdicionalBody,
    values: ProdutoAdicionalItemBody,
): void {
    const adicionais: ProdutoProdutoAdicionalBody[] = formProduto.getFieldValue('adicional') || [];
    const index = adicionais.findIndex((item) => item.pra_idpk === adicional.pra_idpk);

    // Adicional não existe no produto
    if (index === -1) {
        formProduto.setFieldsValue({
            adicional: [
                ...adicionais,
                {
                    ...adicional,
                    alterar: true,
                    item: [values],
                    key: adicional.pra_idpk?.toString() || uuid(),
                },
            ],
        });

        return;
    }

    // Adicional já existe no produto
    const adicionalAtual = adicionais[index];
    if (!adicionalAtual) {
        return;
    }

    const itens = adicionalAtual.item || [];

    // Adicionar novo item
    if (dialogState.mode === 'add') {
        formProduto.setFieldsValue({
            adicional: adicionais.map((item) => {
                if (item.pra_idpk === adicional.pra_idpk) {
                    return {
                        ...item,
                        alterar: true,
                        item: [...itens, values],
                    };
                }

                return item;
            }),
        });

        return;
    }

    // Editar item existente
    if (dialogState.mode === 'edit') {
        formProduto.setFieldsValue({
            adicional: adicionais.map((item) => {
                if (item.pra_idpk === adicional.pra_idpk) {
                    return {
                        ...item,
                        alterar: true,
                        item: itens.map((item) => {
                            if (item.key === values.key) {
                                return values;
                            }

                            return item;
                        }),
                    };
                }

                return item;
            }),
        });

        return;
    }
}

export function removeAdicionalGroupForm(
    formProduto: FormInstance<FormProdutoValues>,
    adicional: ProdutoAdicionalBody,
): void {
    const adicionais: ProdutoProdutoAdicionalBody[] = formProduto.getFieldValue('adicional') || [];
    const index = adicionais.findIndex((item) => item.pra_idpk === adicional.pra_idpk);

    if (index === -1) {
        return;
    }

    formProduto.setFieldsValue({
        adicional: adicionais.map((adc) => {
            if (adc.pra_idpk === adicional.pra_idpk) {
                return {
                    ...adc,
                    alterar: true,
                    excluir: 'S',
                    item:
                        adc.item?.map((item) => ({
                            excluir: 'S',
                            key: item.key,
                            pai_idpk: item.pai_idpk,
                        })) || null,
                };
            }

            return adc;
        }),
    });
}

export function removeAdicionalItemForm(
    formProduto: FormInstance<FormProdutoValues>,
    adicional: ProdutoAdicionalBody,
    item: ProdutoAdicionalItemBody,
): void {
    const adicionais: ProdutoProdutoAdicionalBody[] = formProduto.getFieldValue('adicional') || [];
    const index = adicionais.findIndex((adc) => adc.pra_idpk === adicional.pra_idpk);

    if (index === -1) {
        return;
    }

    formProduto.setFieldsValue({
        adicional: adicionais.map((adc) => {
            if (adc.pra_idpk === adicional.pra_idpk) {
                const itens = adc.item || [];

                return {
                    ...adc,
                    alterar: true,
                    item: itens
                        .map((i) => {
                            if (i.key === item.key) {
                                return {
                                    excluir: 'S' as const,
                                    key: i.key,
                                    pai_idpk: i.pai_idpk,
                                };
                            }

                            return i;
                        })
                        .filter((i) => {
                            if (i.excluir === 'S' && !i.pai_idpk) {
                                return false;
                            }

                            return true;
                        }),
                };
            }

            return adc;
        }),
    });
}
